import { HtmlId } from '../enum';
import { createCarousel } from '@vfde-brix/ws10/carousel';
import { mountComponent } from '../util/mount';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

export const mountCarousel = (id: HtmlId) =>
    mountComponent(id, createCarousel, NO_PATTERN_BUSINESS_LOGIC);
